import React, {useEffect, useState} from 'react';
import classes from "./friends.module.css";
import { Base64 } from 'js-base64';
import {getReferralsAPI, sendMoneyRefAPI} from "../api";
import Referrals from "./referrals/referrals";

const Friends = ({client, getClient}) => {
    const [notification, setNotification] = useState(null)
    const [notification2, setNotification2] = useState(null)
    const [openReferrals, setOpenReferrals] = useState(false)
    const [referrals, setReferrals] = useState([{level1:[],level2:[],level3:[]}])

    useEffect(()=>{
        const getReferrals = async ()=>{
            const res = await getReferralsAPI()
            setReferrals(res)
        }
        getReferrals()
    },[])

    const shareLink = () => {
        let text = `https://t.me/EasyFastVPNBot?start=${Base64.encode(client.telegram_id)}`
        let textAreaValue = '🔥 Я пользуюсь этим VPN, советую и тебе попробовать!'
        window.open(
            `https://t.me/share/url?url=${text}&text=${textAreaValue}`
        );
    };

    const copyLink = () => {
        let text = `https://t.me/EasyFastVPNBot?start=${Base64.encode(client.telegram_id)}`
        navigator.clipboard.writeText(text);
        setNotification('Ссылка скопирована');
        setTimeout(() => setNotification(null), 2000);
    }

    async function sendMoney(){
        if(client.ref_balance > 0){
            await sendMoneyRefAPI()
            getClient()
            setNotification2('Деньги переведены на баланс VPN');
            setTimeout(() => setNotification2(null), 2000);
        }
    }

    return (
        <div className={classes._}>
            <div className={classes.headerText}>Реферальная система</div>
            <div className={classes.headerText2}>Приглашай друзей и получай:
                <br/><br/>
                ✅ <b>25₽ на баланс</b> за каждого приглашенного<br/>
                ✅ <b>Процент с их пополнений</b> на 3 уровня!<br/>
                <br/>
                🔗 <b>1 уровень (друзья):</b> 15% от пополнений приглашенных вами пользователей<br/>
                🔗 <b>2 уровень (друзья друзей):</b> 10% от пополнений пользователей, приглашенных вашими рефералами<br/>
                🔗 <b>3 уровень:</b> 5% от пополнений пользователей, приглашенных рефералами 2-го уровня<br/>
                <br/>
                Заработанные средства можно использовать для оплаты VPN!</div>
            <div className={classes.buttonBlock}>
                {!!notification && <div className={classes.notification}>{notification}</div>}
                <div className={classes.button} onClick={shareLink}>Пригласить друга</div>
                <div className={classes.buttonCopy} onClick={copyLink}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                        <path d="M3.9998 4V1C3.9998 0.44772 4.44752 0 4.9998 0H16.9998C17.5521 0 17.9998 0.44772 17.9998 1V15C17.9998 15.5523 17.5521 16 16.9998 16H13.9998V18.9991C13.9998 19.5519 13.5499 20 12.993 20H1.00666C0.45059 20 0 19.5554 0 18.9991L0.00259995 5.00087C0.00269995 4.44811 0.45264 4 1.00942 4H3.9998ZM2.00242 6L2.00019 18H11.9998V6H2.00242ZM5.9998 4H13.9998V14H15.9998V2H5.9998V4Z" fill="#FFF"/>
                    </svg>
                </div>
            </div>
            <div className={classes.buttonBlock} style={{marginTop:'20px'}}>
                {!!notification2 && <div className={classes.notification}>{notification2}</div>}
                <div className={classes.headerText2} style={{margin:0}}>Ваш реф. баланс: <b>{client.ref_balance}₽</b></div>
                <div className={classes.button} style={{opacity:client.ref_balance > 0?1:0.5}} onClick={sendMoney}>Перевести на счет VPN</div>
            </div>
            <div className={classes.buttonBlock} style={{marginTop:'20px'}}>
                <div className={classes.button} onClick={()=>setOpenReferrals(true)}>Посмотреть друзей</div>
            </div>
            <Referrals isOpen={openReferrals} setIsOpen={setOpenReferrals} data={referrals}/>
        </div>
    );
};

export default Friends;